.exclusion-form {
  padding: 0 calc(2 * var(--spacer));
  &--row {
    padding: 10px 0 var(--spacer) 0;
  }

  &--field {
    margin-right: calc(2 * var(--spacer));
    position: relative;
    height: calc(4 * var(--spacer));

    gz-enum-filter {
      width: 100%;
    }
  }
}

:host {
  height: 0;
  margin-bottom: 50px;
}

@media screen and (max-height: 768px) {
  gz-dropdown {
    --gz-dropdown-max-height: 200px !important;
  }
}
